<template>
  <div class="main">
    <report-top> </report-top>

    <selectTool ref="selectTool">
      <template slot="text">位置标注点列表</template>
      <template slot="btn"
        ><Button @click="getSearchItem" type="error" class="chaxun">查询</Button
        ><Button @click="openAdd" type="primary" class="chaxun">新增</Button>
      </template>
    </selectTool>
    <Table
      border
      :columns="columns"
      :data="tableData"
      no-data-text="<div class='table-no-data'></div>"
      :height="utils.setTableHeight(240)"
    >
      <template slot-scope="{ row, index }" slot="action">
        <Button size="small" @click="opemUpdate(row, index)">编辑</Button>
        <Button size="small" @click="del(row, 1)">删除</Button>
      </template>
    </Table>
    <div id="mypage">
      <div>
        <Page
          :current="1"
          :total="total"
          :page-size="searchItem.pageSize"
          :page-size-opts="[10, 50, 100]"
          show-total
          show-elevator
          show-sizer
          @on-change="changePage"
          @on-page-size-change="pageSizeChange"
        ></Page>
      </div>
    </div>
    <Modal
      v-model="openForm"
      :title="isAdd ? '新增公厕' : '编辑公厕'"
      footer-hide
      fullscreen
      @on-cancel="cliclCancelBtn"
    >
      <div style="width: 100%; height: 100%; position: relative">
        <duobianxing ref="duobianxing"></duobianxing>
        <div id="sderwwetcsd" style="width: 280px">
          <Form
            ref="item"
            :model="item"
            :rules="ruleValidate"
            :label-width="80"
          >
            <Row :gutter="16">
              <Col span="24">
                <FormItem label="名称" prop="name">
                  <Input v-model="item.name" placeholder="请输入"></Input>
                </FormItem>
              </Col>

              <Col span="24">
                <FormItem label="有效半径" prop="radius">
                  <Select v-model="item.radius" @on-change="drawCir">
                    <Option
                      v-for="(x, index) in $t('meters')"
                      :value="x.id"
                      :key="index"
                      >{{ x.name }}</Option
                    >
                  </Select>
                </FormItem>
              </Col>
              <Col span="24">
                <FormItem label="单位名称" prop="groupName">
                  <selectGroup
                    :name="item.groupName"
                    @update:name="item.groupName = $event"
                    :id="item.groupId"
                    @update:id="item.groupId = $event"
                  >
                  </selectGroup>
                </FormItem>
              </Col>
              <Col span="24">
                <FormItem label="绑定路线" prop="routeId">
                  <selectLine
                    :id="item.routeId"
                    @update:id="item.routeId = $event"
                    @on-select="selectLine"
                  >
                  </selectLine>
                </FormItem>
              </Col>
              <Col span="24">
                <FormItem label="标段" prop="landmarkId">
                  <Select v-model="item.landmarkId">
                    <Option
                      v-for="(x, index) in landmarks"
                      :value="x.id"
                      :key="index"
                      >{{ x.name }}</Option
                    >
                  </Select>
                </FormItem>
              </Col>
            </Row>
            <Row type="flex" justify="end">
              <Col span="24">
                <Button type="primary" long @click="next('item')"
                  >下一步</Button
                >
              </Col>
            </Row>
          </Form>
        </div>
      </div>
    </Modal>
    <Modal v-model="openAddress" title="确认当前地址" footer-hide width="400">
      <Form ref="address" :model="item" :rules="ruleValidate" :label-width="80">
        <Row :gutter="16">
          <Col span="24">
            <FormItem label="当前地址" prop="address">
              <Input
                v-model="item.address"
                type="textarea"
                placeholder="请输入"
              ></Input>
            </FormItem>
          </Col>
        </Row>
        <Row type="flex" justify="end">
          <Col span="24">
            <div class="btn-wrap">
              <Button @click="getAdd">重新获取</Button>
              <Button type="primary" @click="addUpdate('address')"
                >完成提交</Button
              >
            </div>
          </Col>
        </Row>
      </Form>
    </Modal>
  </div>
</template>
<script>
import axios from "axios";
import duobianxing from "../map/point.vue";

export default {
  components: { duobianxing },
  data() {
    return {
      openForm: false,
      openAddress: false,
      isAdd: false,
      columns: [
        {
          type: "index",
          width: 70,
          align: "center",
        },
        {
          title: "名称",
          key: "name",
          minWidth: 100,
          maxWidth: 300,
        },
        {
          title: "标段",
          key: "landmarkName",
          minWidth: 100,
          maxWidth: 300,
        },
        {
          title: "地址",
          key: "address",
          minWidth: 200,
          maxWidth: 500,
        },
        {
          title: "绑定路线",
          key: "routeName",
          minWidth: 200,
          maxWidth: 500,
        },
        {
          title: "单位名称",
          key: "groupName",
          minWidth: 100,
          maxWidth: 300,
        },
        {
          title: "创建者账号",
          key: "createAccount",
          minWidth: 100,
          maxWidth: 300,
        },
        {
          title: "创建时间",
          key: "createTime",
          render: (h, data) => {
            return h("div", this.utils.time(data.row.createTime, "yymmdd"));
          },
          minWidth: 100,
          maxWidth: 300,
        },
        {
          title: "操作",
          slot: "action",
          width: 160,
          align: "center",
          fixed: "right",
        },
      ],
      tableData: [],
      item: {
        address: "",
        cs: 2,
        name: "",
        radius: 50,
        groupName: "",
        groupId: 0,
        x: 0,
        y: 0,
        remark: "",
        landmarkId: "",
        //tagId: 1,
        routeId: 0,
      },
      ruleValidate: {
        name: { required: true, message: "必填" },
        landmark: { required: true, message: "必填" },
        groupName: { required: true, message: "必填" },
        terminalNo: { required: true, message: "必填" },
        landmarkId: { required: true, message: "必填" },
        //tagId: { required: true, message: "必填" },
        address: { required: true, message: "必填" },
      },
      pageNumber: 1,
      pageSize: 50,
      total: 0,
      landmarks: [],
      searchItem: {
        pageNumber: 1,
        pageSize: 50,
        total: 0,
        keyword: "",
      },
      searchForms: [
        {
          title: "名称",
          key: "name",
          type: "Input",
        },
        {
          title: "关键词",
          key: "keyword",
          type: "Input",
        },
      ],
    };
  },
  methods: {
    getList() {
      this.utils.loading(this, "加载中");
      axios({
        method: "post",
        url: axios.gc + "/toilet/list",
        data: this.searchItem,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;
        //var data = [{ name: "11111" }];
        this.tableData = data;
        console.log(res);
      });
    },
    addUpdate(name) {
      var ccc = this.$refs.duobianxing.getPoint();
      this.item.x = ccc.x;
      this.item.y = ccc.y;
      console.log(this.item);
      this.$refs[name].validate((valid) => {
        if (valid) {
          if (this.isAdd) {
            axios({
              method: "post",
              url: axios.gc + "/toilet/add",
              data: this.item,
            }).then((res) => {
              if (res) {
                this.openForm = false;
                this.openAddress = false;
                this.getList();
              }
            });
          } else {
            axios({
              method: "post",
              url: axios.gc + "/toilet/update",
              data: this.item,
            }).then((res) => {
              if (res) {
                this.openForm = false;
                this.openAddress = false;
                this.getList();
              }
            });
          }
        }
      });
    },
    //删除公司
    del(row, n) {
      this.$Modal.confirm({
        title: "删除后数据无法恢复，确定要删除？",
        //content: "退出系统后需要重新登录",
        onOk: () => {
          axios({
            method: "post",
            url: axios.gc + "/toilet/del",
            data: { idList: [row.id] },
          }).then((res) => {
            if (res) {
              this.getList();
            }
          });
        },
      });
    },
    //点击编辑按钮
    opemUpdate(row) {
      this.openForm = true;
      this.isAdd = false;
      this.item = row;
      this.$refs.duobianxing.drawMap(row);
      this.getLinesDetail(row.routeId);
    },
    openAdd() {
      this.openForm = true;
      this.isAdd = true;
      this.$refs.duobianxing.drawMap();
    },
    resetForm() {
      this.$refs["item"].resetFields();
    },
    cliclCancelBtn() {
      this.openForm = false;
      var arr = this.tableData;
      this.tableData = [];
      setTimeout(() => {
        this.tableData = arr;
      }, 200);
    },
    changePage(x) {
      this.searchItem.pageNumber = x;
      this.getList();
    },
    //每页总条数切换
    pageSizeChange(x) {
      this.searchItem.pageSize = x;
      this.getList();
    },
    drawCir(v) {
      this.$refs.duobianxing.drawCir(v);
    },
    next(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.openAddress = true;
          if (this.isAdd) {
            this.getAdd();
          }
        }
      });
    },
    getAdd(name) {
      var ccc = this.$refs.duobianxing.getPoint();
      this.item.x = ccc.x;
      this.item.y = ccc.y;

      var pointList = [
        {
          x: this.item.x,
          y: this.item.y,
        },
      ];
      this.utils.jiexi(pointList).then((data) => {
        this.item.address = data[0].address;
        console.log(this.item);
      });
    },
    getLandmark() {
      this.utils.loading(this, "加载中");
      axios({
        method: "post",
        url: axios.gc + "/landmark/list",
        data: {},
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        var data = res.data.data.dataList;
        this.landmarks = data;
      });
    },
    selectLine(v) {
      this.getLinesDetail(v.value);
    },
    getLinesDetail(v) {
      axios({
        method: "post",
        url: axios.rule + "/route/item",
        data: { id: v },
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        var abc = res.data.data;
        this.$refs.duobianxing.showLine([abc]);
      });
    },
    getSearchItem() {
      this.searchItem = this.$refs.selectTool.getItem();
      this.searchItem.pageNumber = 1;
      this.getList();
    },
  },
  mounted() {
    this.getLandmark();
    this.$refs.selectTool.reach(this.searchForms, this.searchItem);
    setTimeout(() => {
      this.getSearchItem();
    }, 200);
  },
};
</script>
<style>
#sderwwetcsd {
  position: absolute;
  background: #fff;
  z-index: 3;
  top: 10px;
  right: 10px;
  padding: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/garbage/toilet.vue